import { useState } from "react";
import { logEvent } from "../../utils/analytics";

import API from "../../utils/api";
import Input from './Input.jsx';
import Button from './Button.jsx';
import {BsCheck} from 'react-icons/bs';

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const SubscribeForm = () => {

    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [feedback, setFeedback] = useState({ message: '', type: '' })

    const onSubscribe = (e) => {
        e.preventDefault();
        if(!email) return;

        logEvent('Subscription', 'Clicked Subscribe button')
        if (!emailRegex.test(email)) {
            setFeedback({ message: 'Pls make sure you entered a valid email', type: 'error' });
            return;
        }

        setLoading(true);
        API.subscribeEmail(email).then((res) => {

            // setFeedback({ message: 'Thank you! Pls check your inbox to confirm your subscription.', type: 'success' });
            setFeedback({ message: 'You have successfully subscribed!', type: 'success' });
        }).catch((err) => {
            console.log(err);
            if (err?.response?.status === 409) setFeedback({ message: 'You have already subscribed!', type: 'success' });
            else setFeedback({ message: 'We could not subscribe you, pls try again', type: 'error' });
        }).finally(() => {
            setLoading(false);
            setTimeout(() => {
                setFeedback({ message: '', type: '' });
            }, 20000)
        })
    }

    const feedbackColors = {
        'error': 'red',
        'success': 'green',
        'info': 'blue',
        'warning': 'yellow'
    }
    return (

        <section className="px-8 pt-8 pb-4">
            <article className="flex flex-col items-center gap-6">
                <div className="space-y-3">
                    <h4 className="tracking-light text-3xl font-bold leading-8 px-4 text-center">Stay in the loop</h4>
                    <p className="text-gray-700 px-4 leading-4 text-center">Get reminded when it's time for the election!</p>
                </div>
                <form className="flex flex-col gap-2 md:w-[300px] w-[300px]" onSubmit={onSubscribe}>

                    <div>
                        <Input onInput={(e) => setEmail(e.target.value)} placeholder="Your email" />

                        {feedback.message && <span className={`mt-2 w-full inline-block text-center text-xs text-${feedbackColors[feedback.type]}-600`}>
                            {feedback.type === 'success' ? <BsCheck className="h-4 w-4 inline-block mb-0.5"/> : ''}
                            {feedback.message}
                        </span>}
                    </div>

                    <div className="text-center py-3">
                        <Button type="submit" disabled={loading}>Subscribe</Button>
                    </div>
                </form>
            </article>
        </section >
    )
}

export default SubscribeForm;
